module.exports = __webpack_public_path__ + "loading.gif";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-file-upload/img/loading.gif
// module id = 812
// module chunks = 1